import { render } from "./admin-news.vue?vue&type=template&id=0a63e346"
import script from "./admin-news.vue?vue&type=script&lang=js"
export * from "./admin-news.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-news.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a63e346"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a63e346', __exports__)) {
    api.reload('0a63e346', __exports__)
  }
  
  module.hot.accept("./admin-news.vue?vue&type=template&id=0a63e346", () => {
    api.rerender('0a63e346', render)
  })

}


export default __exports__